import { LinkInterface } from "@/interface/nav.interface";
import { LinksConstrains } from "@/enums/links.enum";

let links: Array<LinkInterface> = [
  // {
  //   title: "menu.ooc_dashboard",
  //   icon: "dashboard",
  //   href: LinksConstrains.OOC_DASHBOARD,
  // },
  // {
  //   title: "menu.ooc_integration",
  //   icon: "integration",
  //   href: LinksConstrains.OOC_INTEGRATION,
  // },
  {
    title: "menu.ooc_merchants",
    icon: "customers",
    href: LinksConstrains.OOC_MERCHANTS,
  },
  {
    title: "menu.ooc_orders",
    icon: "orders",
    href: LinksConstrains.OOC_ORDERS,
  },
];

export default links;
